import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { managerActions } from '@store/reducers/manager'
import { put, select } from 'redux-saga/effects'

export function* updateProject() {
  const projectId: ID | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (!projectId) {
    return
  }

  // The project is already on screen when the socket (re)connects — refetch
  // in the background without the fullscreen loader.
  yield put(managerActions.fetchProjectSaga({ id: projectId, silent: true }))
}
